// Vendor
import type { Ref } from 'vue'
import { computed, onMounted, onUpdated } from 'vue'

// Stores
import { useUiStore } from 'src/stores/ui'

// Personal libs
import { DeviceOrientation } from 'src/shared/enum/device-orientation.enum'

// https://vuejs.org/guide/reusability/composables.html#mouse-tracker-example
export function useQPageTitle(title: Ref<string>) {
  // Init stores
  const uiStore = useUiStore()

  // Computed properties
  const doAlignCenter = computed<boolean | undefined>(() => true)
  const orientation = computed<DeviceOrientation | undefined>(() => uiStore.uiOrientation)

  onMounted(() => {
    uiStore.pageTitle = title.value
  })

  onUpdated(() => {
    uiStore.pageTitle = title.value
  })

  return {
    // Computed properties
    doAlignCenter, orientation,
  }
}
